<template>
  <b-card class="card bordered shadowed h-100" @click="$emit('onCta')">
    <div class="card-content d-flex justify-content-between flex-column h-100">
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column w-100">
          <b-img :src="image" alt="..." class="mb-2 image" fluid />
          <div>
            <small class="text-bold text-small" v-if="label">{{ label }}</small>
            <p
              class="mb-0 text-right text-small text-disabled white-space-normal"
              v-if="description"
            >
              {{ description }}
            </p>
            <h6 class="mt-0 mb-2 white-space-normal">{{ title }}</h6>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-end buttons-wrapper">
        <slot />
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "BasicCard",
  props: {
    image: String,
    label: String,
    title: String,
    description: String,
  },
};
</script>

<style scoped lang="scss">
.card {
  cursor: pointer;
  border-radius: 0.5rem;
}
.card-body {
  padding: 0;
}
.card-content {
  padding: 1.4rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}
.image {
  max-height: 170px;
}
.link-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.buttons-wrapper {
  position: relative;
  z-index: 1;
}
.text-disabled {
  opacity: 0.5;
}
.white-space-normal {
  white-space: normal;
}
</style>
